import { j as s } from "../../jsx-runtime-B6kdoens.js";
import { useMemo as i } from "react";
import { c as f } from "../../index-CROKJrb5.js";
import { c as m, f as g } from "../../create-component-CBAeEoQ6.js";
import { IconRenderer as p } from "../Icon/index.js";
import { Typography as x } from "../Typography/index.js";
const y = f({
  base: "cur-inline-flex cur-items-center cur-h-5",
  variants: {
    labelType: {
      default: "cur-bg-surface-brand-accent cur-text-body",
      darkBold: "cur-bg-surface-secondary cur-text-inverse",
      icon: "cur-bg-surface-highlight cur-text-brand",
      good: "cur-bg-surface-success cur-text-success",
      bad: "cur-bg-surface-error cur-text-error",
      beforeAfter: "cur-bg-surface-brand cur-text-inverse",
      subtle: "cur-bg-surface-highlight cur-text-brand",
      tally: "cur-bg-surface-brand-accent cur-text-body cur-px-[.5rem] cur-rounded-full",
      dot: "cur-bg-surface-brand-accent cur-w-2 cur-h-2 cur-rounded-full",
      disabled: "cur-bg-curology-neutral-100 cur-text-body"
    },
    size: {
      md: null,
      lg: null
    }
  },
  compoundVariants: [
    {
      size: "md",
      labelType: "icon",
      className: "cur-px-1"
    },
    {
      size: "lg",
      labelType: "icon",
      className: "cur-px-2"
    },
    {
      size: "md",
      labelType: [
        "default",
        "darkBold",
        "good",
        "bad",
        "beforeAfter",
        "subtle",
        "disabled"
      ],
      className: "cur-px-[.3125rem]"
    },
    {
      size: "lg",
      labelType: [
        "default",
        "darkBold",
        "icon",
        "good",
        "bad",
        "beforeAfter",
        "subtle",
        "tally",
        "disabled"
      ],
      className: "cur-h-[2.625rem]"
    },
    {
      size: "lg",
      labelType: [
        "default",
        "darkBold",
        "good",
        "bad",
        "beforeAfter",
        "subtle",
        "tally",
        "disabled"
      ],
      className: "cur-px-4 cur-py-2"
    }
  ]
}), h = ({ size: e }) => i(() => {
  switch (e) {
    case "lg":
      return "body";
    case "md":
    default:
      return "meta";
  }
}, [e]), v = m(
  "Label",
  g(
    ({
      as: e,
      children: t,
      className: u,
      icon: r,
      size: a = "md",
      labelType: c = "default",
      ...l
    }, o) => {
      c = r ? "icon" : c;
      const d = y({
        className: u,
        size: a,
        labelType: c
      }), b = h({ size: a }), n = a === "lg" ? "md" : 12;
      return /* @__PURE__ */ s.jsx(
        x,
        {
          as: e || "aside",
          ref: o,
          className: d,
          size: b,
          weight: "bold",
          ...l,
          children: r ? /* @__PURE__ */ s.jsx(
            p,
            {
              icon: r,
              size: n,
              className: "cur-shrink-0"
            }
          ) : t
        }
      );
    }
  )
);
export {
  v as Label
};
//# sourceMappingURL=index.js.map
